// Vehicle ad_id is not unique, but it seems that ad_id + days_on_stock is
import {AvailableCarWithLogo} from '../types/available-car-with-logo';

export const createVehicleKey = (vehicle: AvailableCarWithLogo) =>
  `${vehicle.ad_id}-${vehicle.days_on_stock}`;
